/* Off Finesse — drawers, bag (real cart), quick add, product page. Vanilla, no dependencies. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };

  function closeAll() {
    $$('.of-drw').forEach(function (d) { d.hidden = true; });
    var s = $('#of-scrim'); if (s) s.hidden = true;
    document.documentElement.style.overflow = '';
  }
  function openDrawer(id) {
    closeAll();
    var d = $('#of-d-' + id), s = $('#of-scrim');
    if (!d) return;
    d.hidden = false; if (s) s.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var c = $('[data-of-close]', d); if (c) c.focus();
  }
  function setCount(n) {
    $$('[data-of-count]').forEach(function (i) { i.textContent = n; i.hidden = !n; });
  }
  function refreshBag() {
    return fetch(root + '?section_id=of-bag', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('of-bag'), cur = document.getElementById('of-bag');
        if (fresh && cur) { cur.innerHTML = fresh.innerHTML; setCount(parseInt(fresh.getAttribute('data-count'), 10) || 0); }
      });
  }
  function post(path, body) {
    return fetch(root + path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function addVariant(id, btn) {
    if (btn) btn.setAttribute('aria-busy', 'true');
    return post('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
      .then(refreshBag).then(function () { openDrawer('bag'); })
      .catch(function (e) { if (btn) { btn.textContent = (e && (e.description || e.message)) || 'That size could not be added'; } })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var o = t.closest('[data-of-open]'); if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-of-open')); return; }
    if (t.closest('[data-of-close]') || t.id === 'of-scrim') { closeAll(); return; }

    var qa = t.closest('[data-of-qa]');
    if (qa) {
      var panel = qa.parentNode.querySelector('.qa'), open = panel.hidden;
      $$('.of-card .qa').forEach(function (p) { p.hidden = true; });
      panel.hidden = !open; qa.setAttribute('aria-expanded', String(open)); return;
    }
    var add = t.closest('[data-of-add]');
    if (add && !add.disabled) { addVariant(add.getAttribute('data-of-add'), add).then(function () { $$('.of-card .qa').forEach(function (p) { p.hidden = true; }); }); return; }

    var rm = t.closest('[data-of-remove]');
    if (rm) { post('cart/change.js', { id: rm.getAttribute('data-of-remove'), quantity: 0 }).then(refreshBag); return; }

    var th = t.closest('[data-of-thumb]');
    if (th) {
      var main = $('#of-gmain'), box = main && main.parentNode;
      if (main) {
        main.src = th.getAttribute('data-src'); main.srcset = ''; main.alt = th.getAttribute('data-alt') || '';
        box.classList.toggle('pk', th.getAttribute('data-pk') === '1');
        $$('[data-of-thumb]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === th)); });
      }
      return;
    }
    var sz = t.closest('[data-of-size]');
    if (sz && !sz.disabled) { pickSize(sz); return; }
    if (t.closest('[data-of-chart]')) {
      e.preventDefault(); var c = $('#of-chart'); if (c) { c.open = true; c.scrollIntoView({ block: 'center' }); }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  function pickSize(btn) {
    var form = $('#of-form'); if (!form) return;
    $$('[data-of-size]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
    var input = $('input[name="id"]', form); input.value = btn.getAttribute('data-of-size'); input.disabled = false;
    var cta = $('#of-add'); cta.disabled = false; cta.textContent = cta.getAttribute('data-add') + ' · ' + btn.getAttribute('data-price');
    var pay = $('#of-pay'); if (pay) pay.hidden = false;
  }
  var form = document.getElementById('of-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      var input = form.querySelector('input[name="id"]'), cta = document.getElementById('of-add');
      if (e.submitter && e.submitter !== cta) return;            // Shop Pay and other dynamic buttons post normally
      e.preventDefault();
      if (!input.value) { cta.textContent = cta.getAttribute('data-pick'); return; }
      addVariant(input.value, cta);
    });
    var only = form.querySelector('[data-of-size][data-only]'); if (only) pickSize(only);
  }
})();
